import { Redirect, useLocation } from '@null-studios/browser-router';
import React, { FunctionComponent } from 'react';

export const RedirectNotFound: FunctionComponent = () => {
  const location = useLocation();

  return <Redirect to={`/not_found?from=${location.pathname}`} />;
};
